var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_+") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u6700\\u7EC8\\u5B9A\\u7A3F",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mint&Stake",
    transform: "translate(-1024.000000, -1025.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-7",
    transform: "translate(120.000000, 873.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_+",
    transform: "translate(916.000000, 164.000000) rotate(-270.000000) translate(-916.000000, -164.000000) translate(904.000000, 152.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    fill: "#FFFDF6",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#FAC31F",
    x: 11.25,
    y: 6.75,
    width: 2.25,
    height: 10.5,
    rx: 1.125
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#FAC31F",
    transform: "translate(12.375000, 12.000000) rotate(-270.000000) translate(-12.375000, -12.000000) ",
    x: 11.25,
    y: 6.75,
    width: 2.25,
    height: 10.5,
    rx: 1.125
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc);
export default __webpack_public_path__ + "static/media/ic_+.7f483e480ff88d7ea7d479f9d79942c6.svg";
export { ForwardRef as ReactComponent };